import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-jichupeizhi",
  "use": "icon-icon-jichupeizhi-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-jichupeizhi\"><path d=\"M822.4 495.232h-50.304V361.152a67.2 67.2 0 0 0-67.072-67.072H570.944V243.84a83.84 83.84 0 0 0-167.68 0v50.24H269.312c-36.928 0-66.752 30.208-66.752 67.072v127.36h49.92a90.56 90.56 0 0 1 0 181.056H202.24v127.36A67.2 67.2 0 0 0 269.248 864h127.36v-50.304a90.56 90.56 0 0 1 181.056 0v50.304h127.36a67.2 67.2 0 0 0 67.072-67.072v-134.08h50.24a83.84 83.84 0 0 0 0-167.616z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-jichupeizhi.svg
// module id = 7LQA
// module chunks = 3